<template>
  <div class="container-mobile-inline-scroll">
    <div class="container-img">
      <img class="container-mobile-inline-scroll__image-full" :src="url" :class="align" />
      <div class="legend" :class="desc_align" v-if="legend">
        <div v-html="legend"></div>
      </div>
    </div>
    
    <div class="author-photo">{{ credit }}</div>
  </div>
</template>

<style lang="scss">
  .container-mobile-inline-scroll {
    position: relative;
    width: 100vw;
    left: calc((100vw - 98%) / 2 * -1);
    margin: 55px 0;

    @media (max-width: 575.98px) {
      left: calc(((100vw - 100%) / 2) * -1);
    }

    .container-img {
      position: relative;
      min-height: 200vh;

      @media (max-width: 575.98px) {
        min-height: 300px;
      }
    }

    &__image-full {
      position: sticky;
      top: 0;
      display: block;
      width: 100%;
      min-height: 100vh;
      object-fit: cover;
      object-position: center top;

      @media (max-width: 575.98px) {
        min-height: 300px;
      }

      &.longer {
        @media (max-width: 575.98px) {
          min-height: 500px;
        }
      }

      &.r-center {
        object-position: 72% top !important;
      }
      

      &.right {
        object-position: 80% top !important;
      }
      
      &.left {
        object-position: 30% top !important;
      }
      
      &.center {
        object-position: 56% top !important;
      }
    }

    .author-photo {
      font: 300 14px 'Lato', sans-serif;
      width: 100%;
      position: relative;
      bottom: 0;
      right: 0;
      color: #747474;
      pointer-events: none;
      text-align: right;
      padding: 5px;
    }

    .legend {
      position: relative;
      margin: 0 auto;
      padding: 10px;
      font-size: 20px;
      font-weight: 300;
      font-family: 'Roboto Slab';
      color: #333;
      background: #ffffffe8;
      width: 100%;
      max-width: 560px;
      text-align: center;
      box-shadow: 0px 0px 2px 2px #33333314;

      &.left {
        margin: 0 auto 0 7% !important;
        max-width: 520px;
      }

      @media (max-width: 575.98px) {
        &.left {
          margin: 0 auto 0 auto !important;
          max-width: 480px;
        }
      }
    }
  }
</style>

<script>
  export default {
    name: 'ImageInlineMobile',
    props: {
      src: {
        type: String,
        default: ``
      }
    },
    computed: {
      url() {
        const path = this.src.split('|')
        if(path[0])
          return path[0]
        return this.src
      },
      legend() {
        const path = this.src.split('|')
        if(path[1])
          return path[1]
        return ``
      },
      align() {
        const path = this.src.split('|')
        if(path[2])
          return path[2]
        return ``
      },
      credit() {
        const path = this.src.split('|')
        if(path[3])
          return path[3]
        return `Andrés Rivera/Univision`
      },
      desc_align() {
        const path = this.src.split('|')
        if(path[4])
          return path[4]
        return ``
      }
    }
  }
</script>